export default __webpack_public_path__ + "static/media/img-0355-central-african-full-face.2f58cc8c.png";